import { render, staticRenderFns } from "./CatalogReservationConfirmation.vue.html?vue&type=template&id=0162a87f&"
import script from "./CatalogReservationConfirmation.component.js?vue&type=script&lang=vueJs&"
export * from "./CatalogReservationConfirmation.component.js?vue&type=script&lang=vueJs&"
import style0 from "./CatalogReservationConfirmation.scss?vue&type=style&index=0&prod&lang=vueScss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports